import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { hideAlert } from '../../redux/alertSlice';
import { RootState } from '../../redux/store';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref}  {...props} />;
});

const AlertBox: React.FC = () => {
  const dispatch = useDispatch();
  const { alertOpen, alertMessage, alertSeverity } = useSelector(
    (state: RootState) => state.alert
  );
  const handleClose = () => {
    dispatch(hideAlert({ severity: alertSeverity }));
  };
  return (
    <Snackbar
      open={alertOpen}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert sx={{
        whiteSpace: "normal",
        wordBreak: "break-word",
        maxWidth: "600px"
      }} onClose={handleClose} severity={alertSeverity} >
        {alertMessage}
      </Alert>
    </Snackbar>
  );
};

export default AlertBox;